import { Component, Input, SimpleChanges, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Client, ClientLicense } from '@mira-avant/mtlibs';
import { LicenseService } from '../../../../services/license';
import { CommonModule } from '@angular/common';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { ZorroModule } from '../../../../modules/zorro.module';
import { PurchaseService } from '../../../../services/purchase';

@Component({
	selector: 'app-licenses-table',
	standalone: true,
	imports: [CommonModule, NzTableModule, NzButtonModule, NzTypographyModule, ZorroModule],
	templateUrl: './licenses-table.html',
	styleUrl: './licenses-table.scss',
})
export class LicensesTable {
	@Input('selectedClient') public selectedClient: Client | undefined;
	@Input('mode') public mode: 'select' | 'edit' = 'edit';
	private sub?: Subscription;
	public licenses: ClientLicense[] = [];

	constructor(
		public licenseService: LicenseService,
		private purchaseService: PurchaseService
	) {
		this.sub = this.purchaseService.purchases$.subscribe(() => {
			this.updateLicenses();
		});
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (!this.selectedClient) {
			this.licenses = [];
			return;
		}

		if (changes['selectedClient']) {
			this.updateLicenses();
		}
	}

	private updateLicenses(): void {
		if (!this.selectedClient) {
			this.licenses = [];
			return;
		}

		this.licenseService
			.getClientLicenses$(this.selectedClient.uuid)
			.then(licenses => {
				this.licenses = licenses;
			})
			.catch(error => {
				console.error('Error fetching licenses:', error);
				this.licenses = [];
			});
	}

	ngOnDestroy(): void {
		this.sub?.unsubscribe();
	}
}
